export const signInDefaults = {
    email: '',
    password: ''
};
export const forgotDefaults = {
    email: ''
};

export const ResetPasswordDefaults = { password: '', confirmPassword: '' };
